import * as React from "react";

import {Helmet}          from "@Common/libs/helmet/helmet";
import {consumeContext}  from "@Common/react/context";
import {Link, makeChain} from "@Common/react/cst2";
import {IgnoreUpdate}    from "@Common/react/ignore-update";
import {Static2}         from "@Common/react/static-2";
import {Types}           from "@Common/types";


const CustomerSupportChat = () => (

    makeChain<JSX.Element>()

    .then(...consumeContext("scheme"))
    .then(...consumeContext("themeScheme"))

    // exit if chat is not enabled
    .then(({scheme, themeScheme}, next:Link<JSX.Element, void>) => {

        if (!scheme?.chatEnabled // used by APM2
            && !themeScheme?.chatEnabled // used by Xpresso
        ) return null;

        return next();

    })

    // ensure never re-rendered
    .then("initialized", (_, next:Link<JSX.Element, Types.Common.React.Static2.Static2Next<boolean>>) => Static2({next}))
    .then(({initialized}, next:Link<JSX.Element, void>) => IgnoreUpdate({
        when: () => {
            let ignoreUpdate = initialized.get();
            if (!ignoreUpdate) initialized.set(true);
            return ignoreUpdate;
        },
        next,
    }))

    // load the script
    .then(() => (
        <Helmet>
            <script>
                {`
                function lcw() {
                    return {
                        chatButtonProps: {
                            styleProps: {
                                iconStyleProps: {
                                    cursor: "pointer",
                                }
                            }
                        },
                        headerProps: {
                            controlProps: {
                                headerIconProps: {
                                    src: "https://xpressdocs.powerappsportals.com/xd_logo_chat_v2.png"
                                },
                                hideTitle: true,
                            },
                            styleProps: {
                                generalStyleProps: {
                                    backgroundColor: "#ffffff",
                                    height: "30px",
                                },
                                iconStyleProps: {
                                    width: "150px",
                                    height: "30px",
                                },
                                minimizeButtonStyleProps: {
                                    color: "#265390"
                                },
                                closeButtonStyleProps: {
                                    color: "#265390"
                                },
                            }
                        }
                    };
                };
                `}
            </script>
            <script v2 id="Microsoft_Omnichannel_LCWidget"
                src="https://oc-cdn-ocprod.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js"
                data-app-id="4ca36d3f-6ee2-4689-aa72-c9972865c50d"
                data-lcw-version="prod"
                data-org-id="3e001f14-682d-443e-a194-75d24577a533"
                data-org-url="https://m-3e001f14-682d-443e-a194-75d24577a533.us.omnichannelengagementhub.com"
                data-customization-callback="lcw">
            </script>
        </Helmet>
    ))

    .run()

);

const OpenCustomerSupportChat = () => {
    // @ts-ignore Microsoft Omnichannel namespace types are not defined
    if (Microsoft === undefined) return;
    // @ts-ignore Microsoft Omnichannel namespace types are not defined
    Microsoft.Omnichannel?.LiveChatWidget?.SDK?.startChat();
}

export {
    CustomerSupportChat,
    OpenCustomerSupportChat
};